<template>
  <div class="cover" ref="cover" :style="setBgStyle()" v-loading="isLoadingImg" v-on="$listeners">
    <img class="bg" :src="materialUrl(bgConfig.src)" alt="" />
    <div
      v-show="elConfig.remainPart === 2 || elConfig.remainPart === 0"
      class="right-element"
      :style="setElementStyle('Right')"
    >
      <img
        ref="RImg"
        :src="materialUrl(elementImg)"
        :style="{
          width: `${elConfig.elementWidth * 2}px`,
        }"
        alt="cover右侧元素"
      />
    </div>
    <div class="texts" :style="textStyle">
      <div v-for="(textMap, index) of fontComputedStyles" :key="index" class="cover-text">
        <span :style="textMap.style" v-html="textMap.text || '请输入文字'"></span>
      </div>
    </div>
    <span class="bottom-label" v-if="lastFontStyle && lastFontStyle.isShowText" :style="lastFontStyle.style">{{
      lastFontStyle.text || "请输入文字"
    }}</span>
  </div>
</template>

<script>
import { getLabelStyleMenu, materialUrl } from "@/assets/scripts/common.js";
import { hexToRGB } from "../../../assets/scripts/utils";
export default {
  name: "cover",
  props: {
    size: {
      required: true,
      type: Object,
    },
    bgConfig: {
      required: true,
      type: Object,
    },
    elementImg: {
      required: true,
      type: String,
    },
    textConfig: {
      required: true,
      type: Object,
    },
    fontStyles: {
      required: true,
      type: Array,
    },
    elConfig: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      // 正在加载图片
      isLoadingImg: false,
      // 文字计算后的样式
      fontComputedStyles: [],
      // 如果是竖版，返回最后一个文字样式
      lastFontStyle: null,
      // 文字样式
      textStyle: {},
    };
  },
  computed: {
    // 背景颜色改变以及labe样式改变
    textChange() {
      return {
        theme: this.bgConfig.tagBgColor,
        fontStyles: this.fontStyles,
      };
    },
    coverImg() {
      return {
        bgConfig: this.bgConfig,
        elementImg: this.elementImg,
      };
    },
    isHorizontal() {
      const { width, height } = this.size;
      return width > height;
    },
  },
  watch: {
    // 文字样式
    textChange: {
      handler({ fontStyles, theme }) {
        // 最后一行置为空
        this.lastFontStyle = null;
        if (!fontStyles.length) return [];
        const labelStyleMenu = getLabelStyleMenu(theme);
        // 文字计算后的样式（添加上单位）
        this.fontComputedStyles = [];
        for (let i = 0; i < fontStyles.length; i++) {
          const fontStyle = fontStyles[i];
          if (!fontStyle.isShowText) continue;
          let style = {};
          const obj = {
            text: fontStyle.text,
            isShowText: fontStyle.isShowText,
          };

          const { fontColor, marginTop, fontSize, lineHeight, fontFamily } = fontStyle;
          style = {
            display: "inline-block",
            color: fontColor,
            marginTop: marginTop + "px",
            fontSize: fontSize + "px",
            fontFamily,
            lineHeight: (lineHeight || fontSize) + "px",
            minHeight: (lineHeight || fontSize) + "px",
          };
          // 处理边框圆角背景样式
          if (fontStyle.isLabelStyle && fontStyle.labelStyle) {
            // 获取文字的背景圆角边框样式
            const labelStyle = labelStyleMenu[fontStyle.labelStyle.substr(-1)].style;
            style.lineHeight = fontSize + "px";
            let padding = (lineHeight - parseInt(fontSize)) / 2;
            // laber样式含有边框行高需要减去边框的宽度
            labelStyle.border && (padding -= 1);
            (style.padding = `${padding - 1}px 0.5em ${padding + 1}px`),
              (style = {
                ...style,
                ...labelStyle,
                textShadow: "none",
              });
          }
          fontStyle.text && (obj.text = fontStyle.text.replace(/\n/, "<br />"));
          obj.style = style;
          // 区分出竖版的最后一行
          if (i === this.fontStyles.length - 1 && !this.isHorizontal) {
            this.lastFontStyle = obj;
          } else {
            this.fontComputedStyles.push(obj);
          }
        }

        // 文字整体位置设置
        // this.setTextBoxStyle();
      },
      deep: true,
      immediate: true,
    },
    // 加载背景图和元素图
    coverImg: {
      handler(newImg) {
        this.isLoadingImg = true;
        this.imgLoading(newImg);
      },
    },
    textConfig: {
      handler(textConfig) {
        this.setTextBoxStyle(textConfig);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    materialUrl,
    // 加载背景图和元素图
    imgLoading(newImg) {
      Promise.all([this.getImg(newImg.bgConfig && newImg.bgConfig.src), this.getImg(newImg.elementImg)]).then(() => {
        this.isLoadingImg = false;
        this.$emit("loaded");
      });
    },
    getImg(imgUrl) {
      return new Promise(resolve => {
        if (!imgUrl) {
          resolve(true);
          return;
        }
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = materialUrl(imgUrl);
      });
    },
    // 设置背景的大小
    setBgStyle() {
      return {
        width: `${this.size.width}px`,
        height: `${this.size.height}px`,
      };
    },
    // 设置元素的位置样式
    setElementStyle(type) {
      let styleObj = {
        width: `${this.elConfig.elementWidth}px`,
        height: `${this.elConfig.elementWidth / 2}px`,
      };
      styleObj[`margin${type}`] = `${-this.elConfig.offsetX}px`;
      return styleObj;
    },
    // 设置文字的位置
    setTextBoxStyle(textConfig) {
      let textPosition = {};
      const { textPositionY, textPositionX, textAlignType } = textConfig;
      if (textPositionY < 0) {
        textPosition.top = "50%";
        textPosition.transform = "translateY(-50%)";
      } else {
        textPosition.top = textPositionY + "px";
      }
      if (textPositionX < 0) {
        textPosition.left = "50%";
        textPosition.transform = "translateX(-50%)";
      } else {
        textPosition.left = 0;
        textPosition.paddingLeft = textPositionX + "px";
      }
      let textHeight = 0;
      for (let i = 0; i < this.fontStyles.length; i++) {
        const fontStyle = this.fontStyles[i];
        if (fontStyle.isMainTitle || /\n/g.test(fontStyle.text)) {
          textHeight += parseInt(fontStyle.lineHeight);
        }
        if (i !== this.fontStyles.length - 1 || this.isHorizontal) {
          textHeight += parseInt(fontStyle.lineHeight) + parseInt(fontStyle.marginTop);
        }
      }
      this.textStyle = {
        ...textPosition,
        height: textHeight + "px",
        textAlign: textAlignType + "" === "0" ? "center" : "left",
        textShadow: `rgba(${hexToRGB(this.bgConfig.textShadowColor)},.6) 0px 2px 4px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  height: 100%;
  z-index: 10;
  background: linear-gradient();
  overflow: hidden;
  .bg {
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .right-element {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    img {
      position: absolute;
      height: auto;
      width: auto;
      bottom: 0;
      right: 0;
    }
  }
  .texts {
    position: absolute;
    padding-top: 1px;
    white-space: nowrap;
    text-align: center;
    z-index: 999;
    line-height: 1;
    color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    right: 0;
    .cover-text {
      display: block;
      font-size: 0;
    }
  }
  .bottom-label {
    position: absolute;
    bottom: 0;
    color: #fff;
    left: 0;
    right: 0;
    font-size: 12px;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    z-index: 999;
  }
}
</style>
